import*as e from"react";function o(o){const{props:r,pickerValueResponse:a}=o;return e.useMemo((()=>({value:a.viewProps.value,open:a.open,disabled:r.disabled??!1,readOnly:r.readOnly??!1})),[a.viewProps.value,a.open,r.disabled,r.readOnly])}export{o as usePickerOwnerState};
//# sourceMappingURL=usePickerOwnerState.js.map
